__turbopack_context__.v({
  "large": "TeaserImage-module-scss-module__PIqPOa__large",
  "premium": "TeaserImage-module-scss-module__PIqPOa__premium",
  "small": "TeaserImage-module-scss-module__PIqPOa__small",
  "teaserImage": "TeaserImage-module-scss-module__PIqPOa__teaserImage",
  "videoContainer": "TeaserImage-module-scss-module__PIqPOa__videoContainer",
  "videoIcon": "TeaserImage-module-scss-module__PIqPOa__videoIcon",
});
